module.exports = __webpack_public_path__ + "img/alba-vignette.80cead39.jpg";